import { FC } from "react";
import Tabs from "@/components/controls/Tabs";
import CounterBadge from "./counter-badge";

export interface FilterTab {
  key: string;
  label: string;
  count: number;
}

interface FilterTabsProps {
  tabs: FilterTab[];
  activeTab: string;
  onTabChange: (tabKey: string) => void;
}

export const FilterTabs: FC<FilterTabsProps> = ({
  tabs,
  activeTab,
  onTabChange
}) => {
  const options: { [key: string]: string | JSX.Element } = {};

  tabs.forEach((tab) => {
    options[tab.key] = (
      <div className="flex items-center gap-[6px]" key={tab.key}>
        <span>{tab.label}</span>
        <CounterBadge count={tab.count} className="filter-tab-badge" />
      </div>
    );
  });

  return (
    <Tabs
      options={options}
      defaultValue={activeTab}
      valueSelected={(value) => onTabChange(value)}
      variant="pill"
      size="lg"
    />
  );
};

export default FilterTabs;
